import { PayloadAction } from '@reduxjs/toolkit';
import app from 'Cloud/Application/app';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { createFolderAction } from 'reactApp/modules/modifying/modifying.actions';
import { ICreateNewItem } from 'reactApp/modules/modifying/modifying.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { getCurrentFolder as getCurrentFolderAction } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { openDisabledFeaturePopupHelper } from 'reactApp/ui/DisabledFeatureDialog/DisabledFeatureDialog.helpers';
import { DisabledFeature } from 'reactApp/ui/DisabledFeatureDialog/DisabledFeatureDialog.types';
import { renderSelectFolderDialog } from 'reactApp/ui/SelectFolderDialog/SelectFolderDialog.toolkit';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { channel } from 'redux-saga';
import { select, take } from 'redux-saga/effects';
import { put } from 'typed-redux-saga';

export function* handleCreateNewItem(action: PayloadAction<ICreateNewItem>) {
    const { type, from, showShareOnlyButton, gaPrefix = '', inHomeRoot = false } = action.payload;
    let showShareButton = action.payload.showShareButton;

    const isFolder = type === 'folder';

    const currentStorage = yield select(getCurrentStorage);
    const { isSearch, isSharedLinks, isTrashBin, isHome, isStart } = getStorage(currentStorage);
    const folder = yield select(getCurrentFolderAction);

    const { isFull } = yield select(UserSelectors.getCloudSpace);

    if (isFull) {
        openDisabledFeaturePopupHelper({ disabledFeature: isFolder ? DisabledFeature.newFolder : DisabledFeature.newFile });
        return;
    }

    let currentFolder = ROOT_FOLDER_ID;

    if (isHome) {
        currentFolder = folder?.id && folder?.id !== ROOT_FOLDER_ID ? folder?.id : ROOT_FOLDER_ID;
    } else if (inHomeRoot || isStart) {
        currentFolder = ROOT_FOLDER_ID;
    } else {
        showShareButton = false;
        const selectChannel = channel();
        renderSelectFolderDialog({
            title: 'Где создать?',
            onSuccess: (answer) => {
                if (answer.action === 'create') {
                    currentFolder = answer.destination;
                    selectChannel.put(true);
                    return;
                }
                selectChannel.close();
            },
        });

        yield take(selectChannel);
        selectChannel.close();
    }

    const storage = isSearch || isSharedLinks || isTrashBin || isStart || isHome ? EStorageType.home : undefined;

    if (isFolder) {
        sendPaymentGa({
            eventCategory: ECategoryGa.created,
            action: 'created-folder',
            type_folder: showShareOnlyButton ? 'common-folder' : 'folder',
            source: from,
        });

        yield put(
            createFolderAction({
                parentFolderId: currentFolder,
                storage,
                showCreateButton: !showShareOnlyButton,
                showShareButton,
                gaPrefix,
            })
        );
        return;
    }

    sendPaymentGa({
        eventCategory: ECategoryGa.created,
        action: 'created-files',
        type_file: type,
        source: from,
    });

    app.editor.createNew(type, null, currentFolder);
}
